import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/banners/HeroSlide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/CityHighlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Maps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Service.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Testimonial.tsx");
